import { mapDataToClient } from '../../../living-info/living-info/mapData';

export class AgreementProperties {
  constructor(agreementProperties) {
    this.apartments = agreementProperties.apartment.map(apartment => mapDataToClient(apartment));
    this.garages = agreementProperties.garage.map(garage => mapDataToClient(garage));
    this.other = agreementProperties.other.map(property => mapDataToClient(property));
  }
}
